var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTenDarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.412 43H79.7236L96.3266 59.5785H85.6332L94.0754 68.0083L133.191 77.843L150.075 96.1074L146.98 100.322H157.955L162.176 96.1074L145.291 77.843L157.955 63.5124L137.412 43Z",
    fill: "#FFFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.08 94.1405L95.201 86.2727H123.623V94.1405H103.08Z",
    fill: "#FFFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71 151.463L78.598 143.595V159.05L71 151.463Z",
    fill: "#FFFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5427 130.388L112.085 110.438H123.623L99.9849 134.322V180.686L91.5427 172.537V130.388Z",
    fill: "#FFFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.085 141.066L143.322 110.438H171.462L183 134.322L168.085 118.868H146.98L120.809 145.562V200.917L112.085 192.488V141.066Z",
    fill: "#FFFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.472 148.653L141.352 141.066V213H133.472V148.653Z",
    fill: "#FFFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.296 200.917V130.388H162.457V192.488L154.296 200.917Z",
    fill: "#FFFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.121 179.281V138.256L183 145.562V171.132L175.121 179.281Z",
    fill: "#FFFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenDarkCircle);
export default __webpack_public_path__ + "static/media/TenDarkCircle.3f800bf18cc8b3a3825cefe474728afd.svg";
export { ForwardRef as ReactComponent };